module.exports = __webpack_public_path__ + "static/img/img_logo.80b1200c.png";